import { createAsyncThunk } from "@reduxjs/toolkit";

//Include Both Helper File with needed methods
import {
    registerEmail as registerEmailApi,
    checkEmailVerification as checkEmailVerificationApi,
    checkMobileVerification as checkMobileVerificationApi,
    sendMobileOtp as sendMobileOtpApi,
    updateAccountType as updateAccountTypeApi,
    registerBusiness as registerBusinessApi,
    registerAdminUser as registerAdminUserApi,
    licensePlanCalculate as licensePlanCalculateApi,
    licensePlanCreate as licensePlanCreateApi,
    processPayment as processPaymentApi,
    getAction as getActionApi,
    getSiteOwnershipOptions as getSiteOwnershipOptionsApi,
    registerSite as registerSiteApi,

    loginEmail as loginEmailApi,
    checkPasscodeLogin as checkPasscodeLoginApi,
    cancelLogin as cancelLoginApi,

    lookupAdvancedCompanyHouse as lookupAdvancedCompanyHouseApi,
    lookupCompanyHouse as lookupCompanyHouseApi,
    getCompanyTypes as getCompanyTypesApi,
    onCancel as onCancelApi,
    cancelRegistration as cancelRegistrationApi,
    onSkip as onSkipApi,
    onBack as onBackApi,
    checkUserRegistrationStatus as checkUserRegistrationStatusApi,
    licensePlansGet as licensePlansGetApi,
} from "../../helpers/backend_helper";

import {
    updateEmailAction, setLoaderAction, setCurrentPageAction, setErrorAction, setUserAction,
    setNextPathnameAction,
    updateBusinessAction,
    updateUserAction,
    updateBusinessLicenseAction,
    updateTandCAction,
    setAccountTypeAction,
    updateAddressesAction,
    clearCompanyHouseResultsAction,
    clearBusinessDetailsAction,
    clearVoucherIsValidAction,
    updateAutoRenewAction,
    updateShowHelpAction,
    resetRegistrationFlowAction,
} from './reducer';
import { setAuthorization } from "helpers/api_helper";

export const registerEmail = createAsyncThunk("co2auth/registerEmail", async (data: any) => {
    try {
        const response = registerEmailApi(data);
        return response;
    } catch (error) {
        return error;
    }
});

export const loginEmail = createAsyncThunk("co2auth/loginEmail", async (data: any) => {
    try {
        const response = loginEmailApi(data);
        return response;
    } catch (error) {
        return error;
    }
});

export const checkEmailVerification = createAsyncThunk("co2auth/checkEmailVerification", async (data: any, thunkAPI: any) => {
    const response: any = await checkEmailVerificationApi(data);
    if (response?.token) {
        setAuthorization(response.token);
    }
    const hasRegistrationAction =
        response?.next_action?.process === 'business_registration'
        || (Array.isArray(response?.actions) && response.actions.some((action: any) => action?.process === 'business_registration'));
    if (hasRegistrationAction) {
        thunkAPI.dispatch(checkUserRegistrationStatus());
    }
    return response;
});

export const checkMobileVerification = createAsyncThunk("co2auth/checkMobileVerification", async (data: any) => {
    try {
        const response = checkMobileVerificationApi({ ...data, is_solving_critical: true });
        return response;
    } catch (error) {
        return error;
    }
});

export const sendMobileOtp = createAsyncThunk("co2auth/sendMobileOtp", async (data: any) => {
    try {
        const response = sendMobileOtpApi({ ...data, is_solving_critical: true });
        return response;
    } catch (error) {
        return error;
    }
});

export const checkPasscodeLogin = createAsyncThunk("co2auth/verifyOTP", async (data: any) => {
    try {
        const response = checkPasscodeLoginApi({ ...data, is_solving_critical: true });
        return response;
    } catch (error) {
        return error;
    }
});

export const cancelLogin = createAsyncThunk("co2auth/cancelLogin", async (data: any) => {
    try {
        const response = cancelLoginApi({ ...data, is_solving_critical: true });
        return response;
    } catch (error) {
        return error;
    }
});

export const updateAccountType = createAsyncThunk("co2auth/updateAccountType", async (data: any) => {
    try {
        const response = updateAccountTypeApi({ ...data, is_solving_critical: true });
        return response;
    } catch (error) {
        return error;
    }
});

export const registerBusiness = createAsyncThunk("co2auth/registerBusiness", async (data: any) => {
    try {
        const response = registerBusinessApi({ ...data, is_solving_critical: true });
        return response;
    } catch (error) {
        return error;
    }
});

export const registerSite = createAsyncThunk("co2auth/registerSite", async (data: any) => {
    try {
        const response = registerSiteApi({ ...data, is_solving_critical: true });
        return response;
    } catch (error) {
        return error;
    }
});

export const lookupAdvancedCompanyHouse = createAsyncThunk("co2auth/lookupAdvancedCompanyHouse", async (data: any) => {
    try {
        const response = lookupAdvancedCompanyHouseApi({ ...data, is_solving_critical: true });
        return response;
    } catch (error) {
        return error;
    }
});

export const lookupCompanyHouse = createAsyncThunk("co2auth/lookupCompanyHouse", async (data: any) => {
    try {
        const response = lookupCompanyHouseApi({ ...data, is_solving_critical: true });
        return response;
    } catch (error) {
        return error;
    }
});

export const getCompanyTypes = createAsyncThunk("co2auth/getCompanyTypes", async (data: any = {}) => {
    try {
        const response = getCompanyTypesApi({ ...data, is_solving_critical: true });
        return response;
    } catch (error) {
        return error;
    }
});

export const getSiteOwnershipOptions = createAsyncThunk("co2auth/getSiteOwnershipOptions", async () => {
    try {
        const response = getSiteOwnershipOptionsApi();
        return response;
    } catch (error) {
        return error;
    }
});

/*
export const addressLookup = createAsyncThunk("co2auth/addressLookup", async (data: any) => {
    try {
        const response = addressLookupApi({ ...data, is_solving_critical: true });
        return response;
    } catch (error) {
        return error;
    }
});

export const addressGet = createAsyncThunk("co2auth/addressGet", async (data: any) => {
    try {
        const response = addressGetApi({ ...data, is_solving_critical: true });
        return response;
    } catch (error) {
        return error;
    }
});
*/

export const registerAdminUser = createAsyncThunk("co2auth/registerAdminUser", async (data: any) => {
    try {
        let response;
        if (typeof FormData !== 'undefined' && data instanceof FormData) {
            if (!data.has('is_solving_critical')) {
                data.append('is_solving_critical', 'true');
            }
            response = registerAdminUserApi(data);
        } else {
            response = registerAdminUserApi({ ...data, is_solving_critical: true });
        }
        return response;
    } catch (error) {
        return error;
    }
});

export const licensePlansGet = createAsyncThunk("co2auth/licensePlansGet", async () => {
    try {
        const response = licensePlansGetApi({ is_solving_critical: true, include_registration_trial: true });
        return response;
    } catch (error) {
        return error;
    }
});

// removed: licensePlanInitialSettings

export const licensePlanCalculate = createAsyncThunk("co2auth/licensePlanCalculate", async (data: any) => {
    try {
        const response = licensePlanCalculateApi({ ...data, is_solving_critical: true });
        return response;
    } catch (error) {
        return error;
    }
});

export const licensePlanCreate = createAsyncThunk("co2auth/licensePlanCreate", async (data: any) => {
    try {
        const response = licensePlanCreateApi({ ...data, is_solving_critical: true });
        return response;
    } catch (error) {
        return error;
    }
});

export const processPayment = createAsyncThunk("co2auth/processPayment", async (data: any) => {
    try {
        const response = processPaymentApi({ ...data, is_solving_critical: true });
        return response;
    } catch (error) {
        return error;
    }
});

export const onCancel = createAsyncThunk("co2auth/onCancel", async (data: any) => {
    try {
        const response = onCancelApi({ ...data, is_solving_critical: true });
        return response;
    } catch (error) {
        return error;
    }
});

export const cancelRegistration = createAsyncThunk("co2auth/cancelRegistration", async (data: any) => {
    try {
        const response = cancelRegistrationApi({ ...data, is_solving_critical: true });
        return response;
    } catch (error) {
        return error;
    }
});

export const onSkip = createAsyncThunk("co2auth/onSkip", async (data: any) => {
    try {
        const response = onSkipApi({ ...data, is_solving_critical: true });
        return response;
    } catch (error) {
        return error;
    }
});

export const onBack = createAsyncThunk("co2auth/onBack", async (data: any) => {
    try {
        const response = onBackApi({ ...data, is_solving_critical: true });
        return response;
    } catch (error) {
        return error;
    }
});

export const getAction = createAsyncThunk("co2auth/getAction", async (data: any) => {
    try {
        const response = getActionApi({ ...data, is_solving_critical: true });
        return response;
    } catch (error) {
        return error;
    }
});

export const checkUserRegistrationStatus = createAsyncThunk("co2auth/checkUserRegistrationStatus", async () => {
    try {
        const response = checkUserRegistrationStatusApi({ is_solving_critical: true });
        return response;
    } catch (error) {
        return error;
    }
});

export const updateEmail = (data: any) => async (dispatch: any) => {
    try {
        dispatch(updateEmailAction(data));
    } catch (error) {
        // console.log(error);
    }
};

export const updateBusiness = (data: any) => async (dispatch: any) => {
    try {
        dispatch(updateBusinessAction(data));
    } catch (error) {
        // console.log(error);
    }
};

export const updateUser = (data: any) => async (dispatch: any) => {
    try {
        dispatch(updateUserAction(data));
    } catch (error) {
        // console.log(error);
    }
};

export const updateBusinessLicense = (data: any) => async (dispatch: any) => {
    try {
        dispatch(updateBusinessLicenseAction(data));
    } catch (error) {
        // console.log(error);
    }
};

export const updateTandC = (data: any) => async (dispatch: any) => {
    try {
        dispatch(updateTandCAction(data));
    } catch (error) {
        // console.log(error);
    }
};

export const updateAddresses = (data: any) => async (dispatch: any) => {
    try {
        dispatch(updateAddressesAction(data));
    } catch (error) {
        // console.log(error);
    }
};

export const updateAutoRenew = (data: any) => async (dispatch: any) => {
    try {
        dispatch(updateAutoRenewAction(data));
    } catch (error) {
        // console.log(error);
    }
};

export const clearCompanyHouseResults = () => async (dispatch: any) => {
    try {
        dispatch(clearCompanyHouseResultsAction());
    } catch (error) {

    }
}

export const clearVoucherIsValid = () => async (dispatch: any) => {
    try {
        dispatch(clearVoucherIsValidAction());
    } catch (error) {

    }
}

export const clearBusinessDetails = () => async (dispatch: any) => {
    try {
        dispatch(clearBusinessDetailsAction());
    } catch (error) {

    }
}

export const resetRegistrationFlow = () => async (dispatch: any) => {
    try {
        dispatch(resetRegistrationFlowAction());
    } catch (error) {

    }
}

export const setLoader = () => async (dispatch: any) => {
    try {
        dispatch(setLoaderAction());
    } catch (error) {
        // console.log(error);
    }
};

export const setCurrentPage = (data: any) => async (dispatch: any) => {
    try {
        dispatch(setCurrentPageAction(data));
    } catch (error) {
        // console.log(error);
    }
};

export const setError = (data: any) => async (dispatch: any) => {
    try {
        dispatch(setErrorAction(data));
    } catch (error) {
        // console.log(error);
    }
};

export const setUser = () => async (dispatch: any) => {
    try {
        dispatch(setUserAction());
    } catch (error) {
        // console.log(error);
    }
};

export const setAccountType = (data: any) => async (dispatch: any) => {
    try {
        dispatch(setAccountTypeAction(data));
    } catch (error) {
        // console.log(error);
    }
};


export const setNextPathname = (data: any) => async (dispatch: any) => {
    try {
        dispatch(setNextPathnameAction(data));
    } catch (error) {
        // console.log(error);
    }
};

export const updateShowHelp = (data: any) => async (dispatch: any) => {
    try {
        dispatch(updateShowHelpAction(data));
    } catch (error) {
        // console.log(error);
    }
};
